import MenuIcon from "@mui/icons-material/Menu"
import { styled } from "@mui/material/styles"
import SideBarSub from "./SideBarSub"
import { getStoredShipper, checkUserPermission } from "../../constants/utils"

import { ExpandMore } from "@mui/icons-material"
import Drawer from "@mui/material/Drawer"
import { colors } from "../../constants/colors"
import {
    Grid,
    List,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material"

import logo from "../../assets/images/wabtec_logo.svg"

const StyledMenuIcon = styled(Grid)({
    cursor: "pointer",
})

const WabtecLogoImg = styled("img")({
    width: "8.125em",
    height: "2.1875em",
})

const StyledAccordion = styled(Accordion)({
    "&.MuiAccordion-root:before": {
        backgroundColor: colors.WHITE,
    },
    "&:hover": {
        backgroundColor: colors.GREY2,
    },
    "&.Mui-expanded": {
        margin: 0,
    },
})

const StyledAccordionSummary = styled(AccordionSummary)({
    "&.Mui-expanded": {
        minHeight: "48px !important",
        backgroundColor: colors.GREY2,
        "& .MuiAccordionSummary-content": {
            "&.Mui-expanded": {
                margin: 0,
            },
        },
    },
    "& + .MuiCollapse-entered": {
        backgroundColor: colors.GREY3,
    },
})

const StyledAccordionDetails = styled(AccordionDetails)({
    display: "list-item",
    padding: 0,
})

const NavText = styled(Typography)({
    fontSize: "0.875rem",
    textDecoration: "none",
    color: colors.BLACK,
    opacity: 0.87,
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.71",
    letterSpacing: "normal",
})

const Header = styled(Grid)({
    marginBottom: "0.5em",
    padding: "0 1.5em",
    height: "3.2em",
    display: "flex",
    alignItems: "center",
    boxShadow:
        "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
})

const StyledList = styled(List)({
    paddingTop: 0,
    paddingBottom: 0,
    "& .MuiListItem-root": {
        paddingLeft: "2em",
    },
    "& .MuiTypography-root": {
        fontWeight: 400,
    },
})
export const SideNavbar = (props) => {
    const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

    const {
        showNavbar,
        toggleNavbar,
        navItems,
        accesRights,
        getEbolToken,
        setEbolRequest,
        showEnhancedVisibilityMenu,
        ebolWOAccess,
    } = props

    return (
        <div data-testid="hamburger-icon">
            <Drawer
                anchor={"left"}
                open={showNavbar}
                onClose={() => toggleNavbar(!showNavbar)}
                data-test="sideNavBar"
            >
                <Header
                    container
                    direction="row"
                    alignItems="center"
                >
                    <StyledMenuIcon item>
                        <MenuIcon onClick={() => toggleNavbar(false)} />
                    </StyledMenuIcon>
                    <Grid item>
                        <WabtecLogoImg
                            src={logo}
                            alt={"Wabtec logo"}
                            data-testid="navbar-logo"
                        />
                    </Grid>
                </Header>
                {STORED_SHIPPER_NAME &&
                    STORED_RAILROAD_NAME &&
                    navItems.map((nav, nav_id) => {
                        return (checkUserPermission(accesRights, nav.id) &&
                            nav.sub) || (nav.id === "shipping" && ebolWOAccess) ? (
                            <StyledAccordion
                                key={nav_id}
                                elevation={0}
                            >
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <NavText
                                        data-test={nav.label}
                                    >
                                        {nav.label}
                                    </NavText>
                                </StyledAccordionSummary>
                                <StyledAccordionDetails>
                                    <StyledList>
                                        {nav.sub.map((nav) => {
                                            return (checkUserPermission(
                                                accesRights,
                                                nav.id
                                            )) || (nav.id === "ebol" && ebolWOAccess)? (
                                                <SideBarSub
                                                    key={nav.id}
                                                    navItem={nav}
                                                    showNavbar={showNavbar}
                                                    toggleNavbar={toggleNavbar}
                                                    getEbolToken={getEbolToken}
                                                    setEbolRequest={
                                                        setEbolRequest
                                                    }
                                                    showEnhancedVisibilityMenu={
                                                        showEnhancedVisibilityMenu
                                                    }
                                                />
                                            ) : null
                                        })}
                                    </StyledList>
                                </StyledAccordionDetails>
                            </StyledAccordion>
                        ) : checkUserPermission(accesRights, nav.id) &&
                          !nav.sub ? (
                            <SideBarSub
                                key={nav.id}
                                navItem={nav}
                                showNavbar={showNavbar}
                                toggleNavbar={toggleNavbar}
                                getEbolToken={getEbolToken}
                                setEbolRequest={setEbolRequest}
                                showEnhancedVisibilityMenu={
                                    showEnhancedVisibilityMenu
                                }
                            />
                        ) : null
                    })}
            </Drawer>
        </div>
    )
}
